class SearchableItemModelT<T> {
    public Model: T;
    public Code: string;
    public Value: string;
    public Value_Searchable: string;

    public Active: boolean;
    public Tag: string;
    public isFavorite: boolean;

    constructor(value: string, code: string = "", model: T = null, value_full: string = "") {
        this.Code = code;
        this.Value = value;

        if (!IsNullOrWhiteSpace(value_full))
            this.Value_Searchable = cacheStore.Helper.RemoveDiacritics(value_full).toLowerCase();
        else if (!IsNullOrWhiteSpace(value))
            this.Value_Searchable = cacheStore.Helper.RemoveDiacritics(value).toLowerCase();

        this.Model = model;
    }

    public static fromObject(obj: { [index: string]: string }): SearchableItemModelT<string>[] {
        if (!obj)
            return null;

        const keys = Object.keys(obj);
        return keys.map(key => new SearchableItemModelT<string>(obj[key], key)).sortByProperty(x => x.Value);
    }
}

class SearchableItemModelSection<T> extends SearchableItemModelT<T> {
    public Section: SearchableSection;

    constructor(section: SearchableSection, value: string, code: string = "", model: T = null, value_full: string = "") {
        super(value, code, model, value_full);
        this.Section = section;
    }
}

class SearchableSection {
    public id: number;
    public code: string;
    public title: string;
    public priority: number;

    public static create(code: string, title: string, priority: number): SearchableSection {
        let section = new SearchableSection();
        section.code = code;
        section.title = title;
        section.priority = priority;
        section.id = sessionStore.newId();

        return section;
    }
}

export { SearchableItemModelSection, SearchableItemModelT, SearchableSection };
